export default __webpack_public_path__ + "static/media/973.ef5fdfce.jpg";